module.exports = __webpack_public_path__ + "static/img/planet2.b2b3560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/he/planet/planet2.png
// module id = tnHQ
// module chunks = 1